import { render } from "./PromReportListView.vue?vue&type=template&id=6962a70c"
import script from "./PromReportListView.vue?vue&type=script&lang=js"
export * from "./PromReportListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__